module.exports = __webpack_public_path__ + "img/man2.089ab3be.jpg";